export enum LayoutMarginToken {
  spacingNone = '0',
  spacingQuarck = '0.4rem',
  spacingNano = '0.8rem',
  spacingXxxs = '1.6rem',
  spacingXxs = '2.4rem',
  spacingXs = '3.2rem',
  spacingSm = '4.0rem',
  spacingMd = '4.8rem',
  spacingLg = '5.6rem',
  spacingXl = '6.4rem',
  spacingXxl = '8.0rem',
  spacingXxxl = '12.0rem',
  spacingHuge = '16.0rem',
  spacingGiant = '20.0rem',
}

export default LayoutMarginToken

export type TMargin =
  | 'spacingNone'
  | 'spacingQuarck'
  | 'spacingNano'
  | 'spacingXxxs'
  | 'spacingXxs'
  | 'spacingXs'
  | 'spacingSm'
  | 'spacingMd'
  | 'spacingLg'
  | 'spacingXl'
  | 'spacingXxl'
  | 'spacingXxxl'
  | 'spacingHuge'
  | 'spacingGiant'
